// Lib
import { createAction } from 'redux-actions';

export const getDashBoardStatistics = createAction('GET_DASHBOARD_STATISTICS');

export const setDashBoardStatistics = createAction('SET_DASHBOARD_STATISTICS');

export const waitForLeavingDashboard = createAction('WAIT_FOR_LEAVING_DASHBOARD');
